import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { API } from '@/context/AuthContext';
import { ArrowLeft, Loader2, AlertTriangle, Clock3 } from 'lucide-react';

const PortalPageView = () => {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setErr('');
      try {
        const { data } = await axios.get(`${API}/pages/${slug}`);
        setPage(data);
      } catch (e) {
        setErr(e?.response?.data?.detail || 'Failed to load');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [slug]);

  return (
    <div>
      <Link to="/portal" className="inline-flex items-center gap-1 text-sm text-slate-600 hover:text-[#1e73be] mb-3">
        <ArrowLeft className="w-4 h-4" /> Back to dashboard
      </Link>
      {loading ? (
        <div className="p-10 text-center text-slate-500 flex items-center justify-center gap-2">
          <Loader2 className="w-4 h-4 animate-spin" /> Loading...
        </div>
      ) : err ? (
        <div className="p-8 rounded-lg border border-red-200 bg-red-50 text-red-700 flex items-center gap-2">
          <AlertTriangle className="w-4 h-4" /> {err}
        </div>
      ) : page ? (
        <article className="bg-white border border-slate-200 rounded-lg p-6 md:p-10">
          <div className="flex flex-wrap gap-1 mb-3">
            {(page.visible_roles || []).map((r) => (
              <span key={r} className="text-[11px] uppercase tracking-wide px-2 py-0.5 rounded-full bg-[#eaf3fb] text-[#1e73be] font-semibold">
                {r}
              </span>
            ))}
          </div>
          <h1 className="font-heading text-3xl md:text-4xl font-bold text-slate-900 mb-2 tracking-tight">
            {page.title}
          </h1>
          {page.excerpt && <p className="text-slate-600 text-lg mb-4">{page.excerpt}</p>}
          <div className="text-xs text-slate-500 mb-6 flex items-center gap-1">
            <Clock3 className="w-3.5 h-3.5" /> Last updated {new Date(page.updated_at).toLocaleString()}
          </div>
          <div
            className="portal-content prose prose-slate max-w-none"
            dangerouslySetInnerHTML={{ __html: page.content || '' }}
          />
        </article>
      ) : null}
    </div>
  );
};

export default PortalPageView;
